import React from 'react';

// Định nghĩa kiểu cho các props của HOC
interface WithNoneAuthenticationProps {
    // Các props khác bạn muốn truyền vào
}

export default function withNonAuthentication<P extends object>(
    WrappedComponent: React.ComponentType<P>
) {
    const WithNoneAuthentication = (props: P & WithNoneAuthenticationProps): React.ReactElement => {
        return <WrappedComponent {...(props as P)} />;
    };

    return WithNoneAuthentication;
}
